import React, { Fragment } from "react";
import Hero2 from "../../components/hero2/hero2";
import About1 from "../../components/about/about";
import FeaturePartners from "../../components/software-company-components/FeaturePartners";
import ServiceSection from "../../components/software-company-components/ServiceSection/ServiceSection";
import About from "../../components/software-company-components/about/about";
import ProcessTechnology from "../../components/software-company-components/ProcessTechnology/ProcessTechnology";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ContactSection from "../../components/software-company-components/ContactSection";
import ProjectSection from "../../components/ProjectSection/ProjectSection";

const HomePage2 = () => {
  return (
    <Fragment>
      <div>
        <main className="page_content">
          <Hero2 />
          <FeaturePartners />
          <ServiceSection />
          <About />
          <ProcessTechnology />
          <About1 />
          <ProjectSection />
          <ContactSection />
        </main>
        <Scrollbar />
      </div>
    </Fragment>
  );
};
export default HomePage2;
